module.exports = "<div class=\"LedContainer\">\r\n    <div class=\"ColorContainer\">\r\n        <div class=\"ColorBox\" [style.background-color]=\"color\" [hidden]=\"!IsOn\"></div>\r\n    </div>\r\n    <div class=\"SliderContainer\">\r\n        <label class=\"switch\">\r\n            <input type=\"checkbox\" [disabled]=\"_IsPlaying\" [(ngModel)]=\"IsOn\" />\r\n            <span class=\"slider round\"></span>\r\n        </label>\r\n    </div>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/Components/LedStatic/LedStatic.component.html
 ** module id = 44
 ** module chunks = 0
 **/